import { Molecule } from 'AppReact';
import styled, { css } from 'styled-components';
import device from 'components/atoms/utils/device';
import { Border, Count, DivWrapper, Name } from './atoms';

const template = styled.div`
  ${({ displayState }) => css`
    display: flex;
    align-items: center;
    cursor: ${displayState?.clickable ? 'pointer' : ''};
    background: ${displayState?.selected ? '#E8F8F0' : ''};
    border-radius: 12px;
    padding: 9px  12px 12px 14px;

    @media ${device.laptop} {
      padding: 9px  23px 12px 14px;
    }
  `}
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: Border,
      name: 'Border',
      displayState: ({ color }) => ({ color }),
      displayValue: ({ }) => '',
    },
    {
      wrapper: DivWrapper,
      name: 'StatsData',
      atoms: [
        {
          component: Count,
          name: 'Count',
          displayValue: ({ count }) => count?.toLocaleString() ?? '0',
        },
        {
          component: Name,
          name: 'Name',
          displayValue: ({ name }) => name,
        },
      ]
    }
  ],
})